/**
 * タイムラインの resource id / event の resourceId を生成する。
 *
 * 割当済み(driverId あり)は `truckId-driverId` とし、同一トラック・同一ドライバーの連続シフトを
 * 1 行に集約する（従来挙動）。未割当(driverId=null)は `truckId-` に潰れて別々の未割当シフトが
 * 衝突し FullCalendar 上で 1 行に統合されてしまうため、delivery 単位で一意化する。
 */
export const buildTimelineResourceId = (
  truckId: number,
  driverId: number | null | undefined,
  deliveryId: number,
): string => (
  driverId != null
    ? [truckId, driverId].join('-')
    : [truckId, 'unassigned', deliveryId].join('-')
);
